module.exports = __webpack_public_path__ + "img/BoneSutureR1.dcb82aa9.jpg";